var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialMessage = function SvgD28SocialMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-28-social-message_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.152941 0 0 0 0 0.149020 0 0 0 0 0.164706 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d-28-social-message_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#030D45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7 11.93v6.536c0 1.052-.868 1.953-1.972 2.029-1.656.15-3.943.225-5.678.225-1.735 0-4.022-.15-5.679-.225-1.104-.076-1.971-.977-1.971-2.029v-6.535l1.183.6 5.442 2.855c.315.15.71.226 1.025.226.315 0 .71-.075 1.025-.226l5.442-2.854 1.183-.601z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.621 10.278c0 .15-.079.376-.236.45l-.947.451-5.994 3.156c-.315.15-.63.15-.946 0l-6.94-3.606c-.158-.075-.316-.226-.237-.376.158-.901.946-1.653 1.972-1.728 1.656-.15 3.943-.225 5.678-.225 1.735 0 4.101.15 5.678.225 1.026.075 1.814.752 1.972 1.653z"
  }))))));
};
export default SvgD28SocialMessage;